import { Link } from "react-router-dom";
import { LogoMark } from "./Logo";

export const Footer = () => (
  <footer data-testid="footer-container" className="mt-24 bg-[var(--ink)] px-5 pt-20 pb-10 text-[var(--bone)] sm:px-10">
    <div className="mx-auto max-w-[1440px]">
      <div className="grid gap-12 md:grid-cols-12">
        <div className="md:col-span-5">
          <LogoMark light className="h-11 w-11" />
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-[#BDB5A8]">
            Objets essentiels pour le bureau, la maison et l'esprit. Expédiés depuis nos ateliers partenaires, sans stock dormant.
          </p>
        </div>
        {[
          ["Sélection", ["Bureau", "Cuisine", "Maison & Jardin", "Bazar", "Outils numériques"]],
          ["Notre modèle", ["Sélection indépendante", "Achat chez nos partenaires", "Liens partenaires signalés"]],
          ["Légal", [["Mentions légales", "/legal/mentions-legales"], ["CGV", "/legal/cgv"], ["Confidentialité", "/legal/confidentialite"], ["Douglas.balech@gmail.com", "mailto:Douglas.balech@gmail.com"]]],
        ].map(([t, ls]) => (
          <div key={t} className="md:col-span-2">
            <p className="font-mono-label text-[11px] text-[#BDB5A8]">{t}</p>
            <ul className="mt-5 space-y-3 text-sm">{ls.map((l) => Array.isArray(l) ? (
              <li key={l[0]}>{l[1].startsWith("/")
                ? <Link to={l[1]} data-testid={`footer-link-${l[1].split("/").pop()}`} className="break-all hover:text-[var(--terra)]">{l[0]}</Link>
                : <a href={l[1]} className="break-all hover:text-[var(--terra)]">{l[0]}</a>}</li>
            ) : <li key={l}>{l}</li>)}</ul>
          </div>
        ))}
      </div>
      <p className="font-display mt-20 select-none text-[21vw] font-light leading-[0.8] tracking-[-0.05em] text-[var(--bone)]">
        Kairos<span className="text-[var(--terra)]">.</span>
      </p>
      <div className="mt-10 flex flex-col gap-3 border-t border-white/15 pt-6 text-xs text-[#BDB5A8] sm:flex-row sm:justify-between">
        <p>© 2026 Kairos — l'instant juste. Tous droits réservés.</p>
        <p>En tant que partenaire Amazon, nous réalisons un bénéfice sur les achats remplissant les conditions requises.</p>
      </div>
    </div>
  </footer>
);
